import React from 'react';

import { Outlet } from 'react-router-dom';
import { withoutAuthentication } from './HOCs';
import { Callback, Login } from './pages';

const authenticationRouter = () => ({
  path: 'auth/*',
  element: <Outlet />,
  children: [
    {
      path: 'callback',
      element: <Callback />
    },
    {
      path: 'login',
      element: withoutAuthentication(Login)
    }
  ]
});

export { authenticationRouter };
